import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
          Spreadsheet <span className="text-accent-500">Features</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feat, idx) => (
            <div
              key={feat.title}
              className="relative bg-background-50 rounded-lg p-5 md:p-6 flex flex-col items-center text-center group cursor-default"
            >
              {idx === 0 && (
                <span className="absolute top-3 left-3 px-2.5 py-0.5 bg-primary-100 text-primary-700 text-[10px] font-bold rounded-full whitespace-nowrap">
                  HOT
                </span>
              )}
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100/70 mb-4 group-hover:bg-accent-200/70 transition-colors duration-200">
                <i className={`${feat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}